import { formatEramMessage, genericAccept, genericReject } from "@poscon/shared-types/eram";
import { baseEramHubConnection } from "./eramHubConnectionFactory";
import { setIsProcessingCommand, setMcaFeedback } from "./eramReact/slices/messagingSlice";
import { dispatchCommandRecall } from "./customEvents";
export function parseSI(msg, client) {
    return async (dispatch) => {
        if (msg.length > 1) {
            dispatch(setMcaFeedback(genericReject(["FORMAT", formatEramMessage(msg)])));
            dispatchCommandRecall();
            return;
        }
        dispatch(setIsProcessingCommand(true));
        try {
            await baseEramHubConnection.connect();
            await baseEramHubConnection.signin(client);
            dispatch(setMcaFeedback(genericAccept([`SIGN IN`])));
        }
        catch (err) {
            if (typeof err === "string") {
                dispatch(setMcaFeedback(genericReject([err.replaceAll("_", " ").toUpperCase()])));
            }
            else {
                console.log(err);
                dispatch(setMcaFeedback(genericReject(["UNKNOWN ERROR"])));
            }
        }
        dispatch(setIsProcessingCommand(false));
        dispatchCommandRecall();
    };
}
//# sourceMappingURL=parseSI.js.map